<template lang="pug">
    //- 车险管理-保单列表首页
    div.insurance-policy-list-home(
        v-if="getAuthority('AutoInsurancePolicyList', 'AutoInsurancePolicyListDetail')"
        v-loading="loading"
        element-loading-text="玩命加载中"
        empty-text="暂未查询到结果"
    )
        div.insurance-policy-list-home-title 保单列表
        DataList(
            ref="dataList"
            :props="props"
            @search="search"
            @beforeExport="exportList"
            @downloadComplete="downloadComplete"
        )
            policy-table(
                :tableData="tableData"
                @refreshList="refreshList"
            )
</template>
<script>
import {mapGetters, mapState} from 'vuex';
import { vehicleInsurancePolicyApis } from '@/api';
import { handleParameter } from '@/filters';
import DataList from '@/components/DataList.vue';
import PolicyTable from './components/PolicyTable';

export default {
    name: 'AutoInsurancePolicyList',
    components: {
        PolicyTable,
        DataList,
    },
    computed: {
        ...mapGetters('user', [
            'getAuthority',
        ]),
        ...mapState('user', [
            'userInfo',
            'orgList',
        ]),
    },
    data() {
        return {
            queryData: null,
            tableData: [],
            loading: true,
            props: {
                total: 0,
                exportUrl: '/insurance/policy/list/export',
                options: [
                    {
                        type: 'select',
                        label: '险别',
                        field: 'riskType',
                        attrs: {
                            placeholder: '请选择',
                            collapseTags: true,
                            filterable: true,
                        },
                        options: [
                            {
                                label: '交强险',
                                value: 'TCI',
                            },
                            {
                                label: '商业险',
                                value: 'VCI',
                            },
                        ],
                    },
                    {
                        type: 'date_range',
                        label: '保险起期',
                        field: 'PolicyStartDate',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy/MM/dd',
                            'default-value': new Date(),
                            editable: false,
                            clearable: true,
                        },
                    },
                    {
                        type: 'date_range',
                        label: '平台支付时间',
                        field: 'PayTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy/MM/dd',
                            'default-value': new Date(),
                            editable: false,
                            clearable: true,
                        },
                    },
                    {
                        type: 'date_range',
                        label: '承保时间',
                        field: 'PolicyTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy/MM/dd',
                            'default-value': new Date(),
                            editable: false,
                            clearable: true,
                        },
                    },
                    {
                        type: 'input',
                        label: '业务员',
                        field: 'operator',
                        attrs: {
                            placeholder: '请输入名称/手机号',
                            maxlength: 64,
                        },
                    },
                    {
                        type: 'input',
                        label: '车架号',
                        field: 'vin',
                        attrs: {
                            placeholder: '请输入',
                            maxlength: 64,
                        },
                    },
                    {
                        type: 'input',
                        label: '车牌号',
                        field: 'plateNumber',
                        attrs: {
                            placeholder: '请输入',
                            maxlength: 64,
                        },
                    },
                    {
                        type: 'input',
                        label: '关联订单号',
                        field: 'orderId',
                        attrs: {
                            placeholder: '请输入',
                            maxlength: 64,
                        },
                    },
                    {
                        type: 'input',
                        label: '保单号',
                        field: 'policyNo',
                        attrs: {
                            placeholder: '请输入',
                            maxlength: 64,
                        },
                    },
                    {
                        type: 'input',
                        label: '关系人信息',
                        field: 'applicant',
                        attrs: {
                            placeholder: '请输入车主/被保人名称、手机号',
                            maxlength: 64,
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.props.exportDisabled = !this.getAuthority('AutoInsurancePolicyList', 'AutoInsurancePolicyListExport');
        if (this.userInfo.mode === 3) {
            const options = this.orgList;
            const multipleProps = {
                type: 'select',
                label: '店铺名称',
                field: 'orgIds',
                options,
                attrs: {
                    filterable: true,
                    multiple: true,
                    'collapse-tags': true,
                },
            };
            this.props.options.push(multipleProps);
        }
    },
    methods: {
        // 查询
        search(params) {
            Object.keys(params).forEach((item) => {
                // eslint-disable-next-line
                if (item.indexOf('Time') > -1 && params[item]) params[item] = this.$dayjs(params[item]).toISOString();
                // eslint-disable-next-line
                if (item.indexOf('Date') > -1 && params[item]) params[item] = this.$dayjs(params[item]).toISOString();
                // eslint-disable-next-line
                if (params[item] === 'all' || params[item] === '') params[item] = null;
                if (Array.isArray(params[item]) && !params[item].length) params[item] = null;
            });
            this.queryData = Object.assign({}, params);
            //  导出参数
            this.props.exportParams = this.queryData;
            handleParameter({
                trackKey: 'vehicle_insurance_list_click_search',
                attr: {
                    ...this.queryData,
                },
            });
            this.getTableData();
        },
        // 根据参数查询列表
        async getTableData() {
            if (!this.getAuthority('AutoInsurancePolicyList', 'AutoInsurancePolicyListDetail')) return;
            this.loading = true;
            try {
                const { data } = await vehicleInsurancePolicyApis.getInsurancePolicy({ ...this.queryData });
                if (!data) return;
                this.tableData = data.list || [];
                this.props.total = data.total || 0;
            } catch (err) {
                throw new Error(err);
            } finally {
                this.loading = false;
            }
        },
        // 刷新列表
        refreshList() {
            this.getTableData();
        },
        // 导出列表
        exportList() {
            this.loading = true;
        },
        downloadComplete() {
            this.loading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
    .insurance-policy-list-home{
        // padding-bottom: 25px;
        @include bg_color(color_base_white);
        &-title{
            height: 50px;
            background: #FFFFFF;
            font-size: 16px;
            color: #333333;
            line-height: 50px;
            border-bottom-style: solid;
            border-bottom-width: 1px;
            @include border_color(color_base_background);
            padding-left: 20px;
            font-weight: bolder;
        }
        .el-pagination {
            text-align: center;
            margin-top: 25px;
        }
    }
</style>
